<template>
  <div>
    <div style="display: flex; justify-content: space-between">
      <Form ref="formItemRef" :model="formItem" :rules="formItemRules" inline>
        <FormItem>
          <DatePicker
            :editable="false"
            type="year"
            v-model="formItem.year"
            style="width: 100px"
            @on-change="getData(true)"
          />
        </FormItem>
        <FormItem prop="search_serialnumber">
          <Select
            clearable
            filterable
            v-model="formItem.search_serialnumber"
            style="width: 400px"
            @on-change="getData(true)"
          >
            <Option
              v-for="cardItem in personalList"
              :value="cardItem.receive_serialnumber"
              :key="cardItem.receive_serialnumber"
              >{{ cardItem.title }}</Option
            >
          </Select>
        </FormItem>
        <FormItem>
          <Button icon="md-add" type="primary" @click="onAdd()"
            >发起沟通</Button
          >
        </FormItem>
      </Form>
      <Button
        type="primary"
        @click="onExport()"
        v-if="roleList.includes('NSrNiCgA') || roleList.includes('pHUYkDnC')"
        >导出</Button
      >
    </div>

    <Card
      dis-hover
      v-for="(cardItem, cardIndex) in msgTable"
      :key="cardIndex"
      style="margin-bottom: 10px"
    >
      <div class="cs-row" style="margin-bottom: 10px">
        <div :id="cardItem.id">
          <Tag color="green">{{ cardItem.relation }}</Tag>
          {{ cardItem.userName }}
          {{ cardItem.positionName }}
          {{ cardItem.date }}
        </div>
        <div class="cs-row" v-if="editType && editCardIndex == cardIndex">
          <Button @click="onEdit(cardIndex, false)">取消</Button>
          <Button
            style="margin-left: 5px"
            type="info"
            @click="onSave(cardIndex)"
            >提交</Button
          >
        </div>
        <div v-else>
          <Button type="warning" @click="onEdit(cardIndex, true)">反馈</Button>
        </div>
      </div>
      <div class="cs-row">
        <div class="cs-col cs-th col-1">类型</div>
        <div class="cs-col cs-th col-3">沟通事项</div>
        <div class="cs-col cs-th col-3">目前进展及后续行动计划</div>
      </div>
      <div
        class="cs-row"
        :key="cardItem.tableFlagKey + 'table' + cardIndex + '-' + rowIndex"
        v-for="(row, rowIndex) in cardItem.connectMidList"
      >
        <div class="cs-col cs-td col-1">
          {{ row.type }}
          <Poptip placement="right" width="1200" trigger="hover">
            <template #content>
              <Table
                class="desc-table"
                :columns="tableColumns"
                :data="tableData"
              ></Table>
            </template>
            <Icon
              v-if="row.type == '增长文化原则'"
              size="18"
              color="blue"
              type="md-help-circle"
            />
          </Poptip>
        </div>
        <div class="cs-col cs-td col-3">
          <div v-if="editType == 'add' && editCardIndex == cardIndex">
            <Input
              v-model="row.text"
              type="textarea"
              :rows="4"
              :maxlength="1000"
              show-word-limit
            />
          </div>
          <div v-else>
            {{ row.text }}
          </div>
        </div>
        <div class="cs-col cs-td col-3">
          <div style="color: #434446">
            <Input
              v-if="
                (editType == 'edit' && editCardIndex == cardIndex) ||
                (editType == 'add' && editCardIndex == cardIndex)
              "
              v-model="row.message"
              type="textarea"
              :rows="4"
              :maxlength="1000"
              show-word-limit
              @on-change=""
            />
            <div
              v-for="(connectRecord, connectRecordIndex) in row.recordList"
              :key="connectRecordIndex"
            >
              <Divider v-if="connectRecordIndex != 0" />
              <div class="cs-row">
                <div>
                  <span class="title-txt">{{ connectRecord.userName }}</span>
                  <span>{{ connectRecord.date }}</span>
                  <span v-if="connectRecord.update_date"
                    >(修改于 {{ connectRecord.update_date }})</span
                  >
                </div>
                <div
                  class="chang-btn"
                  @click="
                    onEditDetail(cardIndex, true, rowIndex, connectRecordIndex)
                  "
                  v-if="!editType && connectRecord.editFlag == '0'"
                >
                  编辑
                </div>
                <div
                  class="red-text"
                  v-if="
                    connectRecord.editFlag != '0' &&
                    connectRecord.be_read == '0'
                  "
                >
                  new
                </div>
              </div>
              <div
                v-if="
                  editType == 'editDeatil' &&
                  editCardIndex == cardIndex &&
                  editTableIndex == rowIndex &&
                  editTableDetailIndex == connectRecordIndex
                "
              >
                <Input
                  v-model="row.message"
                  type="textarea"
                  :rows="4"
                  :maxlength="1000"
                  show-word-limit
                />
              </div>
              <div
                class="content-txt"
                :class="{
                  'noread-txt':
                    connectRecord.editFlag != '0' &&
                    connectRecord.be_read == '0',
                }"
                v-else
                @click="updateContinuedConnectRecordRead(connectRecord)"
              >
                {{ connectRecord.text }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Card>
    <div
      class="load-more"
      v-if="
        msgTable.length != pageInfo.total && pageInfo.total > pageInfo.pageSize
      "
      @click="getNetxtPage()"
    >
      查看更多<Icon type="ios-arrow-down" />
    </div>
    <div class="no-data" v-if="msgTable.length == pageInfo.total">
      -- 没有更多内容了 --
    </div>
    <Spin size="large" fix v-if="spinShow" />
    <Modal v-model="exportModal" title="导出" fullscreen footer-hide>
      <div>
        <FormComponent
          @searchForm="getFormData"
          :searchFormItem="modalFormItem"
          :labelWidth="100"
          ref="FormComponent"
          @handleReset="handleReset"
        >
        </FormComponent>
        <Table
          border
          :loading="modalLoading"
          :columns="modalTableColumns"
          :data="modalTableData"
          style="margin: 20px 0"
        >
          <template slot-scope="{ row, index }" slot="action">
            <Button
              type="primary"
              icon="md-cloud-download"
              size="small"
              @click="onExportCom(row, index)"
            >
              导出
            </Button>
          </template>
        </Table>
        <Page
          :total="modalPageInfo.total"
          :current="modalPageInfo.pageNo"
          :page-size="modalPageInfo.pageSize"
          transfer
          @on-change="modalPageChange"
          :page-size-opts="[10, 50, 100, 150]"
          show-sizer
          @on-page-size-change="modalPageSizeChange"
        />
      </div>
    </Modal>
  </div>
</template>

<script>
import DateUtil from "@/util/DateUtil";
import FormComponent from "../performanceManagement/components/FormComponent";

export default {
  components: { FormComponent },
  data() {
    return {
      date: new DateUtil(),
      formItem: {
        year: "",
        search_serialnumber: "",
      },
      formItemRules: {
        year: [
          {
            required: true,
            message: "请选择年度",
          },
        ],
        search_serialnumber: [
          {
            required: true,
            message: "请选择要沟通对象",
          },
        ],
      },
      yearList: [],
      personalList: [],
      msgTable: [],
      pageInfo: {
        total: 0,
        pageNo: 1,
        pageSize: 10,
      },
      editType: "",
      editCardIndex: null,
      editTableIndex: null,
      editTableDetailIndex: null,
      nowAdd: false,
      spinShow: false,
      isClick: false,
      exportModal: false,
      modalFormItem: {},
      modalPageInfo: {
        total: 0,
        pageNo: 1,
        pageSize: 10,
      },
      modalLoading: false,
      modalTableData: [],
      businessUnitList: [],
      departmentList: [],
      searchItem: {},
      query: {},
      roleList: [],
    };
  },

  mounted() {
    this.getList();
    this.query = this.$route.query || {};
    this.formItem.search_serialnumber = this.query.search_serialnumber;
  },
  computed: {
    //国际化监听
    lang() {
      return this.$store.getters.selectLangeData;
    },
    tableColumns() {
      let arr = [];
      if (this.lang == "zh") {
        arr = [
          {
            title: "增长文化原则",
            key: "msg1",
          },
          {
            title: "行为标准",
            key: "msg2",
          },
        ];
      } else {
        arr = [
          {
            title: "Growth Culture Principles",
            key: "msg1",
          },
          {
            title: "Behavioral Standards",
            key: "msg2",
          },
        ];
      }
      return arr;
    },
    tableData() {
      let arr = [];
      if (this.lang == "zh") {
        arr = [
          {
            msg1: "我们永怀炽热之心（Live by Semper Ardens），不断追求卓越表现",
            msg2: `不止于: 以诚信推动业绩，以激情实现我们的（短期）承诺
更需要: 挑战当下，满怀雄心，树立远大目标，不断创新，以领先于时代`,
          },
          {
            msg1: "我们营造一个充满正能量、具有同理心的工作环境",
            msg2: `不止于: 关注合作，努力工作以完成任务
更需要: 践行同理心、平等和包容，拥抱思想多样性，并共同庆祝成功`,
          },
          {
            msg1: "我们所做的一切始终以消费者为中心",
            msg2: `不止于: 深深自豪于啤酒和品牌管理方面获得的良好财务表现和拥有的丰富经验
更需要: 成为充满激情的品牌大使，在我们所做的一切中为消费者创造价值`,
          },
          {
            msg1: "我们快速决策，卓越交付",
            msg2: `不止于: 以数据为依据，以事实为基础进行决策，并严格执行
更需要: 建立信任，从失败中吸取教训，推动创新，赋能和授权员工，优先追求速度而非完美`,
          },
          {
            msg1: "我们赋能、授权、支持和培养我们的员工，使其充分发挥潜力",
            msg2: `不止于:拥有充满激情和敬业精神的员工队伍，他们的工作热情和职业道德令人钦佩
更需要: 投资于员工的成长，创造相互学习、成长和实践的机会`,
          },
        ];
      } else {
        arr = [
          {
            msg1: "We live by Semper Ardens and constantly strive for the extraordinary",
            msg2: `Beyond: We drive performance and passionately deliver on our (short-term) commitments with integrity
To: We challenge status quo, set stretched ambitions, and innovate to build beyond our time`,
          },
          {
            msg1: "We foster an environment of positive energy and compassion ",
            msg2: `Beyond: We focus on collaboration and working hard to get things done
To: We practice compassion, equity, and inclusion, embrace diversity of thought, and celebrate success`,
          },
          {
            msg1: "We are passionate about the consumer in everything we do ",
            msg2: `Beyond: We have deep pride and experience in beer and managing our brands for sound financial performance 
To: We act as passionate brand ambassadors creating value for consumers in all we do`,
          },
          {
            msg1: "We decide fast and deliver with excellence ",
            msg2: `Beyond: We make data-driven, fact-based decisions and execute with rigour
To: We build trust to learn from failures and drive innovation, empower people, and prioritise speed over perfection`,
          },
          {
            msg1: "We empower, support, and grow our people to reach their full potential ",
            msg2: `Beyond: We have a driven and committed employee base admired for their passion and work ethic
To: We invest in growing our people and creating mutual opportunities to learn, grow, and deliver`,
          },
        ];
      }
      return arr;
    },
    modalTableColumns() {
      return [
        {
          title: "操作" /* 查看 */,
          slot: "action",
          align: "center",
          minWidth: 120,
        },
        {
          title: this.$t("Name") /* 姓名 */,
          key: "userName",
          align: "center",
          minWidth: 120,
        },
        {
          title: this.$t("English_Name") /* 英文名 */,
          key: "userEName",
          align: "center",
          minWidth: 120,
        },
        {
          title: this.$t("Employee_Code") /* 员工号 */,
          key: "empCode",
          align: "center",
          minWidth: 120,
        },
        {
          title: this.$t("BU") /* 业务单元 */,
          key: "businessUnit",
          align: "center",
          minWidth: 120,
        },
        {
          title: this.$t("Position_Name_Chinese") /* 职位 */,
          key: "positionCTitle",
          align: "center",
          minWidth: 120,
        },
        {
          title: this.$t("Position_Name_English") /* 职位 */,
          key: "positionETitle",
          align: "center",
          minWidth: 120,
        },
        {
          title: this.$t("Department") /* 部门 */,
          key: "department",
          align: "center",
          minWidth: 120,
        },
        {
          title: this.$t("Line_Manager") /* 直线上级 */,
          key: "dirSupName",
          align: "center",
          minWidth: 120,
        },
      ];
    },
  },
  methods: {
    getListData() {
      this.axios.post("/achReport/selectAchReportLabelInfo", {}).then((res) => {
        if (res) {
          this.$refs.FormComponent.positionList = res.positionList;
          this.$refs.FormComponent.departmentList = res.departmentList;
          this.$refs.FormComponent.businessUnitList = res.businessUnitList;
          this.$refs.FormComponent.personnelType = res.personnelType;
          this.$refs.FormComponent.salesAreaList = res.salesAreaList;
          this.$refs.FormComponent.YesOrNo = res.YesOrNo;
          this.$refs.FormComponent.BeQuit = res.BeQuit;
          this.$refs.FormComponent.Level = res.Level;
          this.$refs.FormComponent.functionList = res.functionList;
        }
      });
    },
    onExportCom(row) {
      this.$refs.FormComponent.prevent = false;
      this.modalLoading = true;
      this.axios({
        url: "/ContinuedConnectNew/reportConnect",
        method: "post",
        data: {
          serialnumber: row.serialnumber,
          userName: row.userName,
        },
        responseType: "blob",
      }).then((res) => {
        var A =
          this.$store.getters.pageData.axiosHeader["content-disposition"].split(
            "filename="
          )[1];
        var FileSaver = require("file-saver");
        FileSaver.saveAs(new Blob([res]), decodeURIComponent(A));
        this.$refs.FormComponent.prevent = false;
        this.modalLoading = false;
      });
    },
    handleReset() {
      this.modalFormItem = {
        dirSupUserName: "",
      };
    },
    getFormData(item) {
      this.modalPageInfo.pageNo = 1;
      this.getModaData(item);
    },
    getModaData(item) {
      item ? (this.searchItem = JSON.parse(item)) : "";
      let obj = {
        serialnumber: JSON.parse(sessionStorage.getItem("userInfo"))
          .serialnumber,
        ...this.searchItem,
        connectType: 1,
        ...this.modalPageInfo,
      };
      this.modalLoading = true;
      this.axios.post("/TalentInventory/selectUserList", obj).then((res) => {
        if (res) {
          this.modalTableData = res.data;
          this.modalPageInfo.total = parseInt(res.pageInfo.total);
        }
        this.$refs.FormComponent.prevent = false;
        this.modalLoading = false;
      });
    },
    modalPageChange(val) {
      this.modalPageInfo.pageNo = val;
      this.getModaData(JSON.stringify(this.searchItem));
    },
    modalPageSizeChange(val) {
      this.modalPageInfo.pageSize = val;
      this.getModaData(JSON.stringify(this.searchItem));
    },
    onExport() {
      this.exportModal = true;
      this.$nextTick(() => {
        this.getListData();
      });
      this.getFormData(JSON.stringify(this.searchItem));
    },
    getNetxtPage() {
      if (this.isClick) {
        return;
      }
      this.isClick = true;
      this.pageInfo.pageNo++;
      this.getData();
    },
    updateContinuedConnectRecordRead(row) {
      if (row.editFlag == "0" || row.be_read != "0") {
        return;
      }
      row.be_read = 1;
      if (this.isClick) {
        return;
      }
      this.isClick = true;
      this.axios
        .post("/ContinuedConnectNew/updateContinuedConnectRecordRead", {
          id: row.id,
        })
        .then((res) => {
          this.isClick = false;
          if (res) {
            row.be_read = 1;
          }
        });
    },
    getList() {
      this.spinShow = true;
      this.axios.post("/ContinuedConnectNew/searchMaster", {}).then((res) => {
        this.spinShow = false;
        this.yearList = res.yearList || []; // ：年度下拉框  画面默认取值第一条赋值
        this.personalList = res.personalList || []; // : 人员下拉列表
        this.roleList = res.roleList || [];
        this.getData(true);
      });
    },
    getData(flag) {
      if (flag) {
        this.pageInfo.pageNo = 1;
        this.pageInfo.total = 0;
        this.msgTable = [];
      }
      this.spinShow = true;
      this.axios
        .post("/ContinuedConnectNew/searchContinuedConnectList", {
          ...this.formItem,
          sortId: this.query.id,
          year: this.date.dateVal(this.formItem.year, "YYYY"),
          ...this.pageInfo,
        })
        .then((res) => {
          this.spinShow = false;
          this.isClick = false;
          this.nowAdd = false;
          this.editType = "";
          this.editCardIndex = null;
          this.editTableIndex = null;
          this.editTableDetailIndex = null;
          let arr = res.data || [];
          this.msgTable = [...this.msgTable, ...arr];
          this.pageInfo.total = Number(res.pageInfo.total) || 0;
        });
    },
    onAdd() {
      if (this.nowAdd) {
        this.$Message.error("有未提交的数据，请勿重复操作");
        return;
      }
      this.$refs["formItemRef"].validate((valid) => {
        if (valid) {
          let obj =
            this.personalList.find(
              (cardItem) =>
                cardItem.receive_serialnumber ==
                this.formItem.search_serialnumber
            ) || {};
          this.msgTable.unshift({
            relation: obj.relation,
            positionName: obj.receive_position,
            userName: obj.userName,
            date: this.$nowDate.dateVal(new Date(), "YYYY-MM-DD"),
            connectMidList: [
              {
                type: "工作重点",
                connectRecordList: [],
              },
              {
                type: "增长文化原则",
                connectRecordList: [],
              },
            ],
          });
          this.editType = "add";
          this.nowAdd = true;
          this.editCardIndex = 0;
          this.$forceUpdate();
        } else {
          this.$Message.error("请将信息填写完整");
        }
      });
    },
    isEmptyAndNoSpaces(str = "") {
      return str.trim().length === 0;
    },
    onEditDetail(cardIndex, flag, tableIndex, detailIndex) {
      this.msgTable[cardIndex].connectMidList[tableIndex].message =
        this.msgTable[cardIndex].connectMidList[tableIndex].recordList[
          detailIndex
        ].text;
      this.editTableIndex = tableIndex;
      this.editTableDetailIndex = detailIndex;
      this.editType = "editDeatil";
      this.onEdit(cardIndex, flag);
    },
    onEdit(cardIndex, flag) {
      if (!flag) {
        this.msgTable[cardIndex].connectMidList.map((cardItem) => {
          cardItem.message = "";
        });
        if (this.editType == "add") {
          this.msgTable.splice(cardIndex, 1);
          this.nowAdd = false;
        }
        this.editType = "";
        this.editCardIndex = null;
        this.editTableIndex = null;
        this.editTableDetailIndex = null;
      } else {
        if (!this.editType) {
          this.editType = "edit";
        }
        this.editCardIndex = cardIndex;
      }
      this.$forceUpdate();
    },
    onSave(cardIndex) {
      if (this.isClick) {
        return;
      }
      this.isClick = true;
      this.$Modal.confirm({
        title: "提示",
        content: "确定要操作吗？",
        onOk: () => {
          let parms = {};
          let url = "";
          let cardObj = this.msgTable[cardIndex] || {};
          let connectMidList = cardObj.connectMidList || [];
          // 新增沟通
          if (this.editType == "add") {
            let personalObj =
              this.personalList.find(
                (cardItem) =>
                  cardItem.receive_serialnumber ==
                  this.formItem.search_serialnumber
              ) || {};
            let chekflag = true;
            connectMidList.map((item) => {
              if (this.isEmptyAndNoSpaces(item.text)) {
                chekflag = false;
              }
              item.text2 = item.message;
              item.receive_serialnumber = this.formItem.search_serialnumber;
            });
            if (!chekflag) {
              this.$Message.error("请填写沟通事项");
              this.isClick = false;
              return;
            }

            parms = {
              year: this.formItem.year, //年度
              receive_serialnumber: this.formItem.search_serialnumber, //接收人serianlnumber
              send_position: personalObj.send_position, //发起人职位
              receive_position: personalObj.receive_position, //接收人职位
              receive_position_en: personalObj.receive_position_en,
              send_position_en: personalObj.send_position_en,
              relation: personalObj.relation, //接收人与发起人的关系
              connectMidList: connectMidList, //Table数据
            };
            url = "/ContinuedConnectNew/saveContinuedConnectList";
          }
          // 提交反馈内容
          if (this.editType == "edit") {
            parms = [];
            connectMidList.map((cardItem) => {
              if (!this.isEmptyAndNoSpaces(cardItem.message)) {
                parms.push({
                  typeid: cardItem.id, //外层 row id 是 connectMidList中 row 的id
                  receive_serialnumber: cardObj.receive_serialnumber, //外接收人serianlnumber
                  text: cardItem.message, //外内容
                });
              }
            });
            url = "/ContinuedConnectNew/saveContinuedConnectRecord";
          }
          // 修改反馈内容
          if (this.editType == "editDeatil") {
            let tableObj = connectMidList[this.editTableIndex] || {}; //表格数据
            let detailObj =
              tableObj.recordList[this.editTableDetailIndex] || {}; //目前进展及后续行动计划
            parms = {
              id: detailObj.id, //本条数据id  connectRecordList 中 row id
              text: tableObj.message, //内容
            };
            url = "/ContinuedConnectNew/updateContinuedConnectRecord";
          }
          this.spinShow = true;
          this.axios.post(url, parms).then((res) => {
            if (res) {
              this.$Message.success(res);
              this.nowAdd = false;
              this.editType = "";
              this.editCardIndex = null;
              this.editTableIndex = null;
              this.editTableDetailIndex = null;
              this.getData(true);
            } else {
              this.isClick = false;
            }
          });
        },
        onCancel: () => {
          this.isClick = false;
        },
      });
    },
  },
};
</script>

<style scoped lang='scss'>
.load-more {
  cursor: pointer;
  width: 100px;
  margin: auto;
  text-align: center;
  text-decoration: underline;
}
.no-data {
  width: 200px;
  margin: auto;
  text-align: center;
}
.cs-row {
  display: flex;
  justify-content: space-between;
}
.chang-btn {
  cursor: pointer;
}
.title-txt {
  font-weight: bold;
  font-size: 16px;
}
.content-txt {
  // background: #e8eaec;
  color: #000;
}
.noread-txt {
  color: blue;
  cursor: pointer;
  text-decoration: underline;
}

.red-text {
  background: red;
  color: #fff;
  padding: 0 4px;
  border-radius: 12px;
}
.cs-th,
.cs-td {
  border: 1px solid #e8eaec;
  padding: 5px 10px;
  border-right: none;
}
.col-1 {
  flex: 1;
}
.col-3 {
  flex: 3;
}
.cs-th {
  background: #f8f8f9;
  font-size: 16px;
  font-weight: bold;
}
.cs-td {
  border-top: none;
}
.cs-th:nth-last-of-type(1),
.cs-td:nth-last-of-type(1) {
  border-right: 1px solid #e8eaec;
}
.cs-row .ivu-divider-horizontal {
  margin: 10px 0 !important;
}
/deep/ .desc-table .ivu-table-cell span {
  line-height: 1.8 !important;
  font-size: 18px;
}
</style>


// WEBPACK FOOTER //
// src/components/process/MyQuery/ContinuousCommunication.vue